module.exports = __webpack_public_path__ + "img/precious03.cdf7fb86.jpg";